/* VELNA Somn — CloudRest product template.
   One initialiser per section root, safe to run again after a Theme Editor
   reload. Nothing here is required for the page to work: without JavaScript
   the product form still posts to /cart/add. */
(function () {
  'use strict';

  var BOUND = 'vsCloudrestBound';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function refreshCartCount() {
    fetch(cartUrl('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        each(document.querySelectorAll('.somn-cart-count'), function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* --------------------------------------------------------------- main */
  function initMain(root) {
    if (root[BOUND]) return;
    root[BOUND] = true;

    var mainImage = root.querySelector('[data-vs-main-image]');
    var frames = root.querySelectorAll('.gallery-video');
    var thumbs = root.querySelectorAll('[data-vs-thumb]');

    /* a poster chosen in the Theme Editor wins over the video's own preview */
    each(frames, function (frame) {
      var poster = frame.getAttribute('data-vs-poster');
      var video = frame.querySelector('video');
      if (poster && video) video.poster = poster;
    });

    function hideFrames() {
      each(frames, function (frame) {
        frame.hidden = true;
        var video = frame.querySelector('video');
        if (video && !video.paused) video.pause();
        var iframe = frame.querySelector('iframe');
        if (iframe) iframe.src = iframe.src;      // stops an embedded player
      });
    }

    function showFrame(frame) {
      hideFrames();
      if (mainImage) mainImage.hidden = true;
      if (frame) frame.hidden = false;
    }

    each(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        each(thumbs, function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');

        var kind = thumb.getAttribute('data-vs-kind') || 'image';
        if (kind === 'video') {
          showFrame(root.querySelector('[data-vs-main-video]'));
          return;
        }
        if (kind === 'media-video') {
          var id = thumb.getAttribute('data-vs-media');
          showFrame(root.querySelector('[data-vs-media-video="' + id + '"]'));
          return;
        }
        hideFrames();
        if (!mainImage) return;
        mainImage.hidden = false;
        mainImage.style.opacity = '0';
        window.setTimeout(function () {
          mainImage.src = thumb.getAttribute('data-vs-src');
          mainImage.alt = thumb.getAttribute('data-vs-alt') || mainImage.alt;
          mainImage.style.objectPosition = thumb.getAttribute('data-vs-position') || 'center';
          mainImage.style.opacity = '1';
        }, 140);
      });
    });

    var form = root.querySelector('.vs-cloudrest-form');
    if (!form) return;

    var qtyInput = form.querySelector('[data-vs-qty-input]');
    each(form.querySelectorAll('[data-vs-qty]'), function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(button.getAttribute('data-vs-qty'), 10) || 1;
        var next = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.value = Math.max(1, next);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ------------------------------------------------------- variants */
    var variantInput = form.querySelector('[data-vs-variant-id]');
    var priceEl = root.querySelector('[data-vs-price]');
    var buttonPrice = root.querySelector('[data-vs-button-price]');
    var addButton = form.querySelector('[data-vs-add]');
    var dataScript = form.querySelector('[data-vs-variant-data]');
    var variants = [];
    if (dataScript) {
      try { variants = JSON.parse(dataScript.textContent); } catch (e) { variants = []; }
    }
    var selects = form.querySelectorAll('[data-vs-option]');

    /* the struck-through price rendered by Liquid, kept so that rewriting
       the price on a choice or variant change never drops it */
    var priceCompare = '';
    if (priceEl) {
      var priceStruck = priceEl.querySelector('s');
      if (priceStruck) priceCompare = priceStruck.outerHTML;
    }

    function setPrice(label, keepCompare) {
      if (!priceEl) return;
      priceEl.innerHTML = (keepCompare && priceCompare) ? (label + ' ' + priceCompare) : label;
    }

    function currentVariant() {
      if (!variants.length) return null;
      var chosen = [];
      each(selects, function (select) { chosen.push(select.value); });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var hit = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    function applyVariant() {
      var v = currentVariant();
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      if (priceEl) {
        priceCompare = (v.compare_at_price && v.compare_at_price > v.price)
          ? ('<s>' + money(v.compare_at_price) + '</s>')
          : '';
        setPrice(money(v.price), true);
      }
      if (addButton) {
        addButton.disabled = !v.available;
        if (v.available) { addButton.removeAttribute('aria-disabled'); }
        else { addButton.setAttribute('aria-disabled', 'true'); }
      }
      if (buttonPrice) buttonPrice.textContent = money(v.price);
      basePrice = v.price;
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      syncChoice();
    }
    each(selects, function (select) { select.addEventListener('change', applyVariant); });

    /* --------------------------------------------------- ritual choice */
    var choices = root.querySelectorAll('[data-vs-choice]');
    var choiceName = root.querySelector('[data-vs-choice-name]');
    var basePrice = null;
    var activeChoice = 'single';

    function syncChoice() {
      var active = root.querySelector('[data-vs-choice].is-active');
      if (!active) return;
      var label = active.getAttribute('data-vs-price');
      if (activeChoice === 'pair') setPrice(label, false);
      if (buttonPrice) buttonPrice.textContent = label;
    }

    each(choices, function (choice) {
      choice.addEventListener('click', function () {
        each(choices, function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-pressed', 'false');
        });
        choice.classList.add('is-active');
        choice.setAttribute('aria-pressed', 'true');
        activeChoice = choice.getAttribute('data-vs-choice');
        var label = choice.getAttribute('data-vs-price');
        setPrice(label, activeChoice !== 'pair');
        if (buttonPrice) buttonPrice.textContent = label;
        if (choiceName) choiceName.textContent = choice.getAttribute('data-vs-label') || '';
        each(document.querySelectorAll('[data-vs-sticky-price]'), function (el) {
          el.textContent = label;
        });
      });
    });

    /* ------------------------------------------------------ add to cart */
    var status = form.querySelector('[data-vs-status]');
    function say(message) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }
    var S = window.somnStrings || {};

    form.addEventListener('submit', function (event) {
      if (!window.fetch) return;                    // let the browser post it
      event.preventDefault();
      var id = variantInput ? variantInput.value : null;
      if (!id) return;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var items = [{ id: id, quantity: qty }];
      var pair = root.querySelector('[data-vs-choice="pair"].is-active');
      if (pair && pair.getAttribute('data-vs-companion')) {
        items.push({ id: pair.getAttribute('data-vs-companion'), quantity: qty });
      }
      if (addButton) {
        addButton.classList.add('is-loading');
        addButton.setAttribute('aria-busy', 'true');
      }
      say(S.adding || 'ADDING…');
      fetch(cartUrl('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      }).then(function () {
        say(S.added || 'ADDED TO CART');
        refreshCartCount();
      }).catch(function () {
        say(S.error || 'Something went wrong. Please try again.');
      }).then(function () {
        if (addButton) {
          addButton.classList.remove('is-loading');
          addButton.removeAttribute('aria-busy');
        }
        window.setTimeout(function () { say(''); }, 4000);
      });
    });
  }


  /* ------------------------------------------------------------- film */
  function initFilm(root) {
    if (root[BOUND]) return;
    root[BOUND] = true;
    var control = root.querySelector('[data-vs-film-control]');
    if (!control) return;
    var video = root.querySelector('[data-vs-film-video] video');

    function label(paused) {
      control.textContent = paused
        ? control.getAttribute('data-vs-play')
        : control.getAttribute('data-vs-pause');
      control.setAttribute('aria-label', paused
        ? control.getAttribute('data-vs-play-aria')
        : control.getAttribute('data-vs-pause-aria'));
      control.setAttribute('aria-pressed', String(paused));
    }

    control.addEventListener('click', function () {
      if (video) {
        if (video.paused) { video.play(); label(false); }
        else { video.pause(); label(true); }
        return;
      }
      label(root.classList.toggle('is-paused'));
    });

    /* people who asked for less motion get the film held still */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if (video) { video.pause(); } else { root.classList.add('is-paused'); }
      label(true);
    }
  }

  /* -------------------------------------------------- feature explorer */
  function initFeatures(root) {
    if (root[BOUND]) return;
    root[BOUND] = true;

    var stage = root.querySelector('[data-vs-feature-stage]');
    var image = root.querySelector('[data-vs-feature-image]');
    var labelEl = root.querySelector('[data-vs-feature-label]');
    var quoteEl = root.querySelector('[data-vs-feature-quote]');
    var tabsBox = root.querySelector('[data-vs-feature-tabs]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vs-feature-tab]'));
    if (!tabs.length || !tabsBox) return;

    var seconds = parseFloat(root.getAttribute('data-vs-rotate')) || 3.5;
    var index = 0;
    var timer = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function select(tab) {
      tabs.forEach(function (other) {
        other.classList.remove('is-active');
        other.setAttribute('aria-expanded', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-expanded', 'true');
      index = tabs.indexOf(tab);
      if (!stage || !image) return;
      stage.classList.add('is-changing');
      window.setTimeout(function () {
        image.src = tab.getAttribute('data-vs-image');
        image.alt = tab.getAttribute('data-vs-alt') || '';
        var pos = tab.getAttribute('data-vs-position');
        if (pos) image.style.objectPosition = pos;
        if (labelEl) labelEl.textContent = tab.getAttribute('data-vs-label') || '';
        if (quoteEl) quoteEl.textContent = tab.getAttribute('data-vs-quote') || '';
        stage.classList.remove('is-changing');
      }, 220);
    }

    function stop() {
      window.clearInterval(timer);
      tabsBox.classList.add('is-paused');
    }
    function start() {
      window.clearInterval(timer);
      if (reduced) { tabsBox.classList.add('is-paused'); return; }
      tabsBox.classList.remove('is-paused');
      timer = window.setInterval(function () {
        select(tabs[(index + 1) % tabs.length]);
      }, seconds * 1000);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab); start(); });
    });
    tabsBox.addEventListener('mouseenter', stop);
    tabsBox.addEventListener('mouseleave', start);
    tabsBox.addEventListener('focusin', stop);
    tabsBox.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });
    root[BOUND + 'Stop'] = stop;
    start();
  }


  /* ----------------------------------------------------------- ledger */
  function initLedger(root) {
    if (root[BOUND]) return;
    root[BOUND] = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vs-ledger]'));
    if (!tabs.length) return;
    var panels = Array.prototype.slice.call(root.querySelectorAll('.ledger-panel'));

    function show(tab) {
      tabs.forEach(function (other) {
        other.classList.remove('is-active');
        other.setAttribute('aria-selected', 'false');
        other.tabIndex = -1;
      });
      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.tabIndex = 0;
      var panel = document.getElementById(tab.getAttribute('data-vs-ledger'));
      if (panel) { panel.hidden = false; panel.classList.add('is-active'); }
    }

    tabs.forEach(function (tab, i) {
      tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;
      tab.addEventListener('click', function () { show(tab); });
      tab.addEventListener('keydown', function (event) {
        var step = 0;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') step = 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') step = -1;
        if (!step) return;
        event.preventDefault();
        var next = tabs[(i + step + tabs.length) % tabs.length];
        show(next);
        next.focus();
      });
    });
  }


  /* ---------------------------------------------------------- reviews */
  function initReviews(root) {
    if (root[BOUND]) return;
    root[BOUND] = true;
    var toggle = root.querySelector('[data-vs-review-toggle]');
    if (!toggle) return;
    var extras = Array.prototype.slice.call(root.querySelectorAll('.photo-review-card.is-extra'));
    var counter = root.querySelector('[data-vs-review-count]');

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      extras.forEach(function (card) { card.hidden = expanded; });
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.textContent = expanded
        ? toggle.getAttribute('data-vs-more')
        : toggle.getAttribute('data-vs-less');
      if (counter) {
        counter.textContent = expanded
          ? counter.getAttribute('data-vs-label-shown')
          : counter.getAttribute('data-vs-label-all');
      }
      if (expanded) {
        window.setTimeout(function () {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 60);
      }
    });
  }

  /* -------------------------------------------------------------- faq */
  function initFaq(root) {
    if (root[BOUND]) return;
    root[BOUND] = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('.faq-item'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  /* ----------------------------------------------------------- sticky */
  function initSticky(root) {
    if (root[BOUND]) return;
    root[BOUND] = true;

    var main = document.querySelector('[data-vs-main]');
    var buyBox = document.querySelector('[data-vs-buybox]');
    var footer = document.querySelector('[data-vs-footer]');
    var priceEl = root.querySelector('[data-vs-sticky-price]');
    var variantInput = root.querySelector('[data-vs-sticky-variant]');
    var qtyInput = root.querySelector('[data-vs-sticky-qty]');
    var form = root.querySelector('.vs-cloudrest-sticky-form');
    var button = root.querySelector('[data-vs-sticky-add]');

    if (window.IntersectionObserver && buyBox) {
      new IntersectionObserver(function (entries) {
        root.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0.15 }).observe(buyBox);
    }
    if (window.IntersectionObserver && footer) {
      new IntersectionObserver(function (entries) {
        root.classList.toggle('is-footer', entries[0].isIntersecting);
      }, { threshold: 0.04 }).observe(footer);
    }

    /* mirror whatever the buy box currently has selected */
    function sync() {
      if (!main) return;
      var mainVariant = main.querySelector('[data-vs-variant-id]');
      var mainQty = main.querySelector('[data-vs-qty-input]');
      var mainButtonPrice = main.querySelector('[data-vs-button-price]');
      if (mainVariant && variantInput) variantInput.value = mainVariant.value;
      if (mainQty && qtyInput) qtyInput.value = parseInt(mainQty.value, 10) || 1;
      if (mainButtonPrice && priceEl) priceEl.textContent = mainButtonPrice.textContent.trim();
      var mainAdd = main.querySelector('[data-vs-add]');
      if (mainAdd && button) {
        button.disabled = mainAdd.disabled;
        if (mainAdd.disabled) { button.setAttribute('aria-disabled', 'true'); }
        else { button.removeAttribute('aria-disabled'); }
      }
    }
    if (main) {
      main.addEventListener('click', function () { window.setTimeout(sync, 0); });
      main.addEventListener('change', function () { window.setTimeout(sync, 0); });
      sync();
    }

    if (!form) return;
    form.addEventListener('submit', function (event) {
      if (!window.fetch) return;
      event.preventDefault();
      sync();
      var id = variantInput ? variantInput.value : null;
      if (!id) return;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var items = [{ id: id, quantity: qty }];
      var pair = main ? main.querySelector('[data-vs-choice="pair"].is-active') : null;
      if (pair && pair.getAttribute('data-vs-companion')) {
        items.push({ id: pair.getAttribute('data-vs-companion'), quantity: qty });
      }
      var S = window.somnStrings || {};
      var label = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = S.adding || 'ADDING…'; }
      fetch(cartUrl('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      }).then(function () {
        if (button) button.textContent = S.added || 'ADDED TO CART';
        refreshCartCount();
      }).catch(function () {
        if (button) button.textContent = S.error || 'ERROR';
      }).then(function () {
        window.setTimeout(function () {
          if (button) { button.disabled = false; button.textContent = label; }
        }, 2500);
      });
    });
  }

  /* -------------------------------------------------------------- boot */
  function init(scope) {
    var context = scope || document;
    each(context.querySelectorAll('[data-vs-main]'), initMain);
    each(context.querySelectorAll('[data-vs-film]'), initFilm);
    each(context.querySelectorAll('[data-vs-features]'), initFeatures);
    each(context.querySelectorAll('.ledger-shell'), initLedger);
    each(context.querySelectorAll('[data-vs-reviews]'), initReviews);
    each(context.querySelectorAll('[data-vs-faq]'), initFaq);
    each(context.querySelectorAll('[data-vs-sticky]'), initSticky);
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', function () { init(); }); }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    each(event.target.querySelectorAll('[data-vs-main],[data-vs-film],[data-vs-features],.ledger-shell,[data-vs-reviews],[data-vs-faq],[data-vs-sticky]'), function (el) {
      if (el[BOUND + 'Stop']) el[BOUND + 'Stop']();
      el[BOUND] = false;
    });
  });
})();
